import { useCallback, useEffect } from 'react';

export function useOutsideAlerter(ref: any, callback: () => void) {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const thisCallback = useCallback(callback, []);

  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event: any) {
      if (ref.current && !ref.current.contains(event.target)) {
        thisCallback();
      }
    }
    // Bind the event listener
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('mousedown', handleClickOutside);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ref]);
}
